module.exports = __webpack_public_path__ + "static/media/logo-higa-login.c39c22d4.png";